import React from 'react'
import styles from './CircledIcon.scss'
import { Icon } from 'common/Icon'

// <Icon /> in a $darkteal (by default) circle-- used in a lot of empty content placeholders
export const CircledIcon = ({ i, size, ringColor }) => {
  return (
    <div className={styles.CircledIcon} style={{ height: size, minWidth: size, borderColor: ringColor }}>
      <Icon i={i} size={size / 2} />
    </div>
  )
}
